/**
 * Handles user navigation input for better focus management.
 * 
 * This script identifies whether a user is navigating through the site using the keyboard or the mouse. 
 * It helps in applying appropriate CSS classes to manage focus states effectively.
 * 
 * Specifically:
 * - Adds the class `user-is-tabbing` to the `body` element when the user is navigating with the keyboard.
 * - Removes the `user-is-tabbing` class when the user interacts with the site using the mouse.
 * 
 * This improves focus handling and accessibility, ensuring that focus styles are visible when navigating 
 * with the keyboard while preventing unnecessary focus styles when using the mouse.
 * 
 * For further reading on managing focus states:
 * https://medium.com/hackernoon/removing-that-ugly-focus-ring-and-keeping-it-too-6c8727fefcd2
 * 
 * @function handleFirstTab - Adds `user-is-tabbing` class on keyboard navigation.
 * @function handleMouseDownOnce - Removes `user-is-tabbing` class on mouse interaction.
 */
document.addEventListener('DOMContentLoaded', () => {
    
    const handleFirstTab = (e) => {
        if (e.keyCode === 9) {
            document.body.classList.add('user-is-tabbing');
            window.removeEventListener('keydown', handleFirstTab);
            window.addEventListener('mousedown', handleMouseDownOnce);
        }
    };

    const handleMouseDownOnce = () => {
        document.body.classList.remove('user-is-tabbing');
        window.removeEventListener('mousedown', handleMouseDownOnce);
        window.addEventListener('keydown', handleFirstTab);
    };

    window.addEventListener('keydown', handleFirstTab);
	
});